export interface SaaSMetadata {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    userAgent: string;
    language: string;
    screenResolution: string;
}

/**
 * Récupère les paramètres UTM depuis l'URL
 */
export const getUTMParams = () => {
    const params = new URLSearchParams(window.location.search);
    const utms: Record<string, string> = {};

    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(key => {
        const val = params.get(key);
        if (val) utms[key] = val;
    });

    return utms;
};

/**
 * Prépare les métadonnées de connexion
 */
export const getConnectionMetadata = () => {
    return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        platform: (navigator as any).platform || 'unknown'
    };
};

/**
 * Tentative de récupération de l'IP (nécessite un service tiers ou cloud function)
 * Pour l'instant on utilise un service public gratuit
 */
export const fetchIpInfo = async () => {
    try {
        // Utilisation directe de ipapi.co qui supporte le HTTPS gratuitement
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error();
        const data = await response.json();

        return {
            ip: data.ip,
            location: `${data.city}, ${data.country_name}`
        };
    } catch (err) {
        console.warn("Erreur lors de la récupération de l'IP:", err);
        return { ip: 'unknown', location: 'unknown' };
    }
};
